(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const setGlobalHeaderHeight = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  };

  window.addEventListener('load', setGlobalHeaderHeight);
  window.addEventListener('resize', setGlobalHeaderHeight);
  window.matchMedia('(max-width: 990px)').addEventListener('change', setGlobalHeaderHeight);

  // Bien-Etre nav: open the Shop mega menu on hover (desktop) while keeping <details> for a11y.
  const beShop = document.getElementById('be-shop-menu');
  if (beShop && window.matchMedia('(min-width: 990px)').matches) {
    let closeTimer = null;
    const panel = beShop.querySelector('.be-nav__panel');

    const openMenu = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      beShop.open = true;
    };

    const scheduleClose = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        beShop.open = false;
      }, 150);
    };

    beShop.addEventListener('pointerenter', openMenu);
    beShop.addEventListener('pointerleave', scheduleClose);

    if (panel) {
      panel.addEventListener('pointerenter', openMenu);
      panel.addEventListener('pointerleave', scheduleClose);
    }
  }

  /* Scroll hide/sticky: assets/be-header.js (rebuild). This class only sets --header-height. */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      setGlobalHeaderHeight();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
